import React from 'react';
import './ReadOnlyNote.scss';

/* Says why a page that is made to be changed shows nothing to change it with. */
export const ReadOnlyNote = ({ children }) => (
    <div className={'read-only-note'}>
        <i className={'material-icons'}>lock</i>
        <span>{children}</span>
    </div>
);
